var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$route.name == 'Review a submitted death record')?_c('TheReviewASubmittedDeathRecordRightAside'):_vm._e(),(this.$route.name == 'Order form')?_c('TheMinicartAside'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }